import { userConstants } from './constantData';

const commonDimensions = [
  'v_play_source', /* 21 */
  'v_section_name', /* 31 */
  'v_list_position', /* 32 */
  'v_tab', /* 33 */
  'v_component_type', /* 42 */
  'v_vertical_position_carousel', /* 60 */
];

export const CAROUSELS_DATA = {
  carousels: {
    watch_carousels: {
      hash: 'e-029.044.001.000.000.009',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
        'v_content_name', /* 17 */
        'v_content_type', /* 18 */
        'v_content_id', /* 19 */
        'v_genre', /* 20 */
        'v_channel_name', /* 23 */
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_transmission_type', /* 34 */
        'v_provider_name', /* 35 */
        'v_collection_name', /* 36 */
        'v_content_locked', /* 37 */
        'v_section_id', /* 48 */
        'v_channel_id', /* 50 */
        'v_episode_number', /* 52 */
        'v_content_player_type', /* 53 */
        'v_primary_genre', /* 54 */
        'v_episode_name', /* 55 */
        'v_is_sports', /* 66 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
        'v_is_betting', /* 81 */
        'v_source',
      ],
    },
    see_more: {
      hash: 'e-029.044.001.000.000.134',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
  },
};
